import React from 'react';
import classnames from 'classnames/bind';
import { ChatAgentButtonBase } from '../../../../../../../components/ChatAgent/components/ChatAgentButtonBase/ChatAgentButtonBase';
import { useReportComfortableViewParam } from '../../../hooks/useReportComfortableViewParam';
import styles from './fixWithAiButton.module.scss';

const classNameBuilder = classnames.bind(styles);

export const FixWithAiButton = ({ data }) => {
    const [isComfortableViewEnabled] = useReportComfortableViewParam();

    return (
        <div
            className={classNameBuilder('container', {
                'comfortable-view': isComfortableViewEnabled,
            })}
            aria-label="Fix with AI"
        >
            <ChatAgentButtonBase
                id="CRT_CREATIVE_REJECTION_FIX"
                messageId="abby.creative.rejection"
                eventData={{
                    creative: data,
                }}
            />
        </div>
    );
};
